var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgKnowlege = function SvgKnowlege(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 4.106a1 1 0 0 0-.82-.013l-9.42 4.053c-.824.355-.8 1.532.039 1.853l9.405 3.597a1 1 0 0 0 .769-.022l7.316-3.298v6.99a1 1 0 0 0 1 1H21a1 1 0 0 0 1-1V9.177a1 1 0 0 0-.576-.906l-8.912-4.166zM6.91 13.78a1 1 0 0 0-1.402.916v1.864a1 1 0 0 0 .599.916l5.557 2.435a1 1 0 0 0 .867-.03l4.537-2.387a1 1 0 0 0 .534-.885v-1.787a1 1 0 0 0-1.465-.885l-4.032 2.12L6.91 13.78z"
  })));
};

export default SvgKnowlege;